import React from 'react';
import { Section } from './ui/Section';
export function TruthSection() {
  return <Section className="bg-primary text-center" data-id="element-176">
      <div className="max-w-3xl mx-auto space-y-8" data-id="element-177">
        <h2 className="text-3xl md:text-5xl font-black text-white tracking-tight" data-id="element-178">
          La verdad incómoda
        </h2>

        <div className="space-y-6 text-xl md:text-2xl text-text-secondary leading-relaxed" data-id="element-179">
          <p data-id="element-180">El problema no es tu producto.</p>
          <p data-id="element-181">
            El problema es que tu sistema actual te permite{' '}
            <span className="text-white font-bold underline decoration-accent-blue underline-offset-4" data-id="element-182">
              postergar para siempre
            </span>
            .
          </p>
          <p data-id="element-183">Porque un embudo grande es el escondite perfecto:</p>
          <div className="bg-section p-6 rounded-lg border-l-4 border-accent-blue inline-block my-4" data-id="element-184">
            <p className="text-white italic font-medium" data-id="element-185">
              "Todavía no vendo porque me falta X…"
            </p>
          </div>
          <p className="text-white font-bold" data-id="element-186">Este método corta ese ciclo.</p>
        </div>
      </div>
    </Section>;
}